


























import Vue from 'vue'
import ContainerV1 from './container.vue'
import PageHeader from './header.vue'
import Breadcrumb from './breadcrumb.vue'
import LeftNavbar from './left-navbar.vue'
export default Vue.extend({
  name: 'HawaDesignerV1',
  components: { PageHeader, ContainerV1, LeftNavbar, Breadcrumb },
})
